package org.dronda.app.web.service

import kotlinx.browser.window

class OwntracksConfigurationService() {
    fun openOwntracksLink(username: String, password: String) {
        val parameters = mapOf(
            "_type" to "configuration",
            "username" to username,
            "password" to password,
            "auth" to "true",
            "mode" to 3,
            "monitoring" to 1,
            "url" to "https://plm.dronda.org/location/event",
        )

        val json = buildString {
            appendLine("{")
            parameters.entries.forEachIndexed { index, (key, value) ->
                append("\"$key\":")
                if (value is String) {
                    append("\"${value}\"")
                } else {
                    append(value)
                }
                if (index != parameters.entries.size - 1) {
                    append(",")
                }
                appendLine()
            }
            appendLine("}")
        }
//
        val uri = "owntracks:///config?inline=${window.btoa(json)}"

        window.open(uri, "_blank")
//        val data = "data:text/plain;charset=utf-8,${encodeURIComponent(uri)}"
//
//        val anchor = document.createElement("a") as HTMLAnchorElement
//        anchor.href = data
//        anchor.setAttribute("download", "config.otrc")
//        anchor.style.display = "none"
//        document.body?.appendChild(anchor)
//        anchor.click()
//        document.body?.removeChild(anchor)
    }
}

private external fun encodeURIComponent(str: String): String
